/* i18n-scan-ignore-file: datos de maqueta: grupos y cantidades a fuego */
import React, {Dispatch, SetStateAction} from 'react'
import {Button, ListGroup, Offcanvas} from 'react-bootstrap'
import {FormattedMessage, defineMessages} from 'react-intl'

// Datos de ejemplo: este panel todavia no esta cableado a la API (ver plan §10).
const SAMPLE_FORM_URL = 'app.apizeal.com/agency/maxcapital'
const SAMPLE_ACTIVE = '90'
const SAMPLE_INACTIVE = '10'
const SAMPLE_CANDIDATES = '0'

const M = defineMessages({
  formUrl: {id: 'admin.users.aside.formUrl', defaultMessage: 'New agent application form URL:'},
  activeUsers: {id: 'admin.users.status.activeUsers', defaultMessage: 'Active users'},
  inactiveUsers: {id: 'admin.users.status.inactiveUsers', defaultMessage: 'Inactive users'},
  candidates: {id: 'admin.users.status.candidates', defaultMessage: 'Candidates'},
  groupsTitle: {id: 'admin.users.groups.title', defaultMessage: 'User Groups'},
  allUsers: {id: 'admin.users.groups.allUsers', defaultMessage: 'All Users'},
  manage: {id: 'common.action.manage', defaultMessage: 'Manage'},
})

const FILTERS_NAME_ARR = [
  {name: 'Agentes Independientes', quantity: 0, color: 'primary'},
  {name: 'Call Center USA', quantity: 7, color: 'dark'},
  {name: 'Contratos', quantity: 3, color: 'light'},
  {name: 'Grupo Roberto Ramirez', quantity: 4, color: 'success'},
  {name: 'Operaciones', quantity: 5, color: 'warning'},
  {name: 'Procesamiento', quantity: 3, color: 'success'},
  {name: 'Prueba comisiones', quantity: 3, color: 'warning'},
  {name: 'Support', quantity: 11, color: 'dark'},
]

export const OffCanvaAsideFilters: React.FC<{
  isOpen: boolean
  onClose: () => void
  tabFilters: string
  setTabFilters: Dispatch<SetStateAction<string>>
  onOpenManage: () => void
}> = ({isOpen, onClose, setTabFilters, tabFilters, onOpenManage}) => {
  return (
    <Offcanvas show={isOpen} onHide={onClose}>
      <Offcanvas.Header closeButton>
        <span />
      </Offcanvas.Header>
      <Offcanvas.Body style={{scrollbarWidth: 'none'}}>
        {/* <div
          style={{
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            boxShadow: '0 1px 3px rgba(0, 0, 0, .12), 0 1px 2px rgba(0, 0, 0, .24)',
            backgroundColor: '#fff',
            marginBottom: '20px',
            borderRadius: '4px',
            padding: '8px 10px',
          }}
        > */}
        <div
          style={{
            borderBottom: '2px solid rgba(93, 120, 255, 0.2)',
            paddingBottom: '7px',
          }}
        >
          <h5 style={{fontSize: '13px'}}>
            <FormattedMessage {...M.formUrl} />
          </h5>
          <a href='#/'>{SAMPLE_FORM_URL}</a>
        </div>

        <div className='my-4'>
          <div className='d-flex w-100 justify-content-between align-items-center mb-2'>
            <span className='fw-bold'>
              <FormattedMessage {...M.activeUsers} />
            </span>
            <span className='badge badge-success'>{SAMPLE_ACTIVE}</span>
          </div>
          <div className='d-flex w-100 justify-content-between align-items-center mb-2'>
            <span className='fw-bold'>
              <FormattedMessage {...M.inactiveUsers} />
            </span>
            <span className='badge badge-danger'>{SAMPLE_INACTIVE}</span>
          </div>
          <div className='d-flex w-100 justify-content-between align-items-center mb-2'>
            <span className='fw-bold'>
              <FormattedMessage {...M.candidates} />
            </span>
            <span className='badge badge-primary'>{SAMPLE_CANDIDATES}</span>
          </div>
        </div>

        <div>
          <div
            style={{
              borderBottom: '2px solid rgba(93, 120, 255, 0.2)',
            }}
            className='d-flex align-items-center justify-content-between'
          >
            <h5>
              <FormattedMessage {...M.groupsTitle} />
            </h5>
            <Button
              variant='link'
              onClick={() => {
                onClose()
                onOpenManage()
              }}
            >
              <i className='bi bi-pencil-square me-1' style={{color: 'inherit'}} />
              <FormattedMessage {...M.manage} />
            </Button>
          </div>
          <ListGroup className='mt-5' variant='flush'>
            <ListGroup.Item
              action
              variant={tabFilters === 'All Users' ? 'primary' : 'light'}
              className='my-2 py-4'
              onClick={() => setTabFilters('All Users') /* i18n-ok: clave de estado */}
            >
              <i className='bi bi-person-fill fs-3 me-1' style={{color: 'inherit'}} />
              <FormattedMessage {...M.allUsers} />
            </ListGroup.Item>
            {FILTERS_NAME_ARR.map((lis) => (
              <ListGroup.Item
                key={lis.name}
                action
                variant={tabFilters === lis.name ? 'primary' : 'light'}
                className='my-1 py-4 d-flex align-items-center justify-content-between'
                onClick={() => setTabFilters(lis.name)}
              >
                <span className='d-flex align-items-center justify-content-between gap-1'>
                  <i className='bi bi-file-person-fill fs-3 me-1' style={{color: 'inherit'}} />
                  {lis.name}
                </span>
                <span className={`badge badge-${lis.color}`}>{lis.quantity}</span>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
        {/* </div> */}
      </Offcanvas.Body>
    </Offcanvas>
  )
}
